import { z } from 'zod';
import { ConfigValidationError, formatValidationError, } from './errors.js';
export function validateConfig(schema, data, context) {
    try {
        return schema.parse(data);
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            const issues = error.issues.map((issue) => ({
                path: issue.path.join('.'),
                message: issue.message,
            }));
            const contextMsg = context ? ` for ${context}` : '';
            const message = `Configuration validation failed${contextMsg}`;
            throw new ConfigValidationError(message, issues);
        }
        throw error;
    }
}
export function safeParseConfig(schema, data) {
    try {
        const result = schema.parse(data);
        return { success: true, data: result };
    }
    catch (error) {
        return {
            success: false,
            error: formatValidationError(error),
        };
    }
}
function readEnvVar(name) {
    if (typeof globalThis !== 'undefined' && 'Deno' in globalThis) {
        return globalThis.Deno.env.get(name);
    }
    if (typeof process !== 'undefined') {
        return process.env[name];
    }
    return undefined;
}
export function getEnvironmentVariable(name, defaultValue) {
    const value = readEnvVar(name) ?? defaultValue;
    if (value === undefined) {
        throw new Error(`Environment variable ${name} is not set`);
    }
    return value;
}
export function detectEnvironment() {
    const env = readEnvVar('APP_ENV') ?? readEnvVar('NODE_ENV') ?? 'local';
    switch (env) {
        case 'local':
            return 'local';
        case 'staging':
        case 'stage':
            return 'staging';
        case 'production':
        case 'prod':
            return 'production';
        default:
            console.warn(`Unknown environment: ${env}, defaulting to local`);
            return 'local';
    }
}
